import React, { lazy, Suspense } from 'react';
import './sass/unauth.scss';
import {
  BrowserRouter as Router,
  Route, Switch, Redirect
} from "react-router-dom";

import Welcome from './Unauth/Welcome.js';
import Loading from './Unauth/Loading.js';
import { SnackContextProvider } from './Util/Snacks';

const SignUp=lazy(()=>import(/* webpackChunkName: 'SignUp' */ './Unauth/Join.js'));
const EmailSent=lazy(()=>import(/* webpackChunkName: 'SignUp' */ './Unauth/EmailSent.js'));
const Verify=lazy(()=>import(/* webpackChunkName: 'SignUp' */ './Unauth/Verify.js'));
const SelectStep=lazy(()=>import(/* webpackChunkName: 'SignUp' */ './Unauth/SelectStep.js'));
const PaymentStep=lazy(()=>import(/* webpackChunkName: 'SignUp' */ './Unauth/PaymentStep.js'));
//const FinishSignUp=lazy(()=>import(/* webpackChunkName: 'SignUp' */ './Unauth/Download.js'));
const ForgotPassword=lazy(()=>import(/* webpackChunkName: 'SignUp' */ './Unauth/ForgotPassword.js'));
const ResetPwdVerify=lazy(()=>import(/* webpackChunkName: 'SignUp' */ './Unauth/ResetPwdVerify.js'));

const Dashboard=lazy(()=>import(/* webpackChunkName: 'Dashboard' */ './Dashboard/Dashboard.js'));

function Dash() {
	return (
		<Suspense fallback={ <Loading /> }>
			<Suspense fallback={ <Loading /> }>
				<Dashboard />
			</Suspense>
		</Suspense>
	)
}

function App() {
  return (
		<SnackContextProvider>
			<Router basename="/Dashboard">
				<Switch className="switch-wrapper">
					<Route path="/Sign-Up" component={SignUp} />
					<Route path="/poolboy" component={SignUp} render={(props) => <SignUp affiliateid={1} {...props} /> } />
					<Route path="/Poolboy" component={SignUp} render={(props) => <SignUp affiliateid={1} {...props} /> } />
					<Route path="/Select-Inspections" component={SelectStep} />
					<Route path="/Payment" component={PaymentStep} />
					<Route path="/Forgot-Password" component={ForgotPassword} />
					<Route path="/Email-Sent" component={EmailSent} />
					/*
					*/
					<Route path="/Finish-Sign-Up">
						<Redirect to="/" />
					</Route>
					<Route path="/Verify/:token+" component={Verify} />
					<Route path="/Reset-Password-Verify/:token+" component={ResetPwdVerify} />
					<Route exact path="/Welcome"><Welcome /></Route>
					<Route path="/" component={Dash} />
					<Route path="/:feature" component={Dash} />
				</Switch>

			</Router>
		</SnackContextProvider>
  );
}

export default App;